export default "__VITE_ASSET__DrZMNXX6__"